/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// redux utils
import { createSlice } from '@reduxjs/toolkit';
// thunks
import { 
    fetchModerationConfig, updateModerationConfig
} from '../thunks/moderation'
// mock data
import { moderationData } from 'data/moderation_data';

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2 SLICE : REDUCER ~~~~~~~~~~ ========== */

const initialState = {
    status: 'initial',
    isUpdating: false,
    moderationConfig: {
      moderationConfigId: "uuid",
      moderationType: "POST_MODERATION"
    }
};


export const moderationSlice = createSlice({
    name: 'moderation',
    initialState,
    reducers: {

    },
    extraReducers: builder => {
      builder
        // fetch commenting config
        .addCase(fetchModerationConfig.pending, (state, action) => {
            state.status = 'pending'
        })
        .addCase(fetchModerationConfig.fulfilled, (state, action) => {
            state.status = 'fulfilled'
            state.moderationConfig = action.payload
        })
        .addCase(fetchModerationConfig.rejected, (state, action) => {
            state.status = 'rejected'
        })   

        // update moderation config
        .addCase(updateModerationConfig.pending, (state, action) => {
            state.isUpdating = true
        })
        .addCase(updateModerationConfig.fulfilled, (state, action) => {
            if(action.payload) state.moderationConfig = action.payload
            state.isUpdating = false
        })
        .addCase(updateModerationConfig.rejected, (state, action) => {
            state.isUpdating = false
        })      

    }
});

export default moderationSlice.reducer;
